/** @flow */

import React, { useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { localize } from "redux-i18n";
import { IconButton, Icons, Button, ButtonGroup, ContextMenu, MenuItem } from "@components";
import actionCreators from "@modules/reporting/actionCreator";
import { View } from "@components";
import { getHistoricReportModal } from "@modules/reporting/selectors/modals";

type OwnProps = $Exact<{
  clientId?: number,
  reportName: string,
  showCurrentReportBtn?: boolean,
  reportToSave?: ?Object,
  currentReport?: ?Object,
  columns: string[],
  handleSubmitVisibleColumns: (string[]) => void,
  navigationHandler: () => void,
  setReportToSave?: (data: ?Object) => void,
  updateReport?: (data: Object) => void,
  transformFilters?: (filters: Object) => Object,
}>;

type PropsFromDispatch = $Exact<{
  toggleSaveReportModal: typeof actionCreators.ToggleSaveReportModal,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

export function ReportTitle(props: Props) {
  const { reportToSave, currentReport } = props;

  const reportSaveData = {
    modalName: props.t("SAVE_REPORT"),
    fieldName: props.t(reportToSave && reportToSave.isNew ? "REPORT_NAME" : "NEW_REPORT_NAME"),
    submitButtonName: props.t("SAVE"),
    submitButtonMaterialIcon: "save",
    name: (reportToSave || {}).name || "",
  };

  const reportSaveAsData = {
    modalName: props.t("SAVE_AS_REPORT"),
    fieldName: props.t("NEW_REPORT_NAME"),
    submitButtonName: props.t("SAVE"),
    submitButtonMaterialIcon: "save",
    name: `${(reportToSave || {}).name} ` || "",
  };
  // Save As
  function handleSaveAsReport() {
    props.toggleSaveReportModal({
      visible: true,
      data: reportSaveAsData,
      type: "save_as",
      report: reportToSave,
      callback: () => {
        props.setReportToSave && props.setReportToSave(null);
      },
    });
  }

  // Save
  function handleSaveReport() {
    if (props.updateReport && reportToSave && reportToSave.id) {
      props.updateReport({
        clientId: props.clientId,
        reportId: reportToSave.id,
        data: {
          id: reportToSave.id,
          name: reportToSave.name,
          createdAt: reportToSave.createdAt,
          filters: props.transformFilters
            ? props.transformFilters(reportToSave.filters)
            : reportToSave.filters,
          columns: reportToSave.columns || props.columns,
        },
        shouldFetchReportData: true,
      });
    } else {
      props.toggleSaveReportModal({
        visible: true,
        data: reportSaveData,
        type: "save",
        report: reportToSave,
        callback: () => {
          if (reportToSave && reportToSave.id) {
            handleSaveMySavedReport();
            return;
          }
          props.setReportToSave && props.setReportToSave(null);
        },
      });
    }
  }

  function handleSaveMySavedReport() {
    if (!props.setReportToSave) {
      return;
    }
    if (props.updateReport && reportToSave) {
      props.updateReport({
        clientId: props.clientId,
        reportId: reportToSave.id,
        data: {
          id: reportToSave.id,
          name: reportToSave.name,
          createdAt: reportToSave.createdAt,
          columns: reportToSave.columns || props.columns,
          filters: props.transformFilters
            ? props.transformFilters(reportToSave.filters)
            : reportToSave.filters,
        },
        shouldFetchReportData: true,
      });
    }
  }

  return (
    <View direction="row" justifyContent="space-between" flex={1} alignItems="center">
      <View direction="row">
        <IconButton
          icon={<span className="material-icons font-size-30 pointer">arrow_back</span>}
          onClick={props.navigationHandler}
          className="ml-0 mr-4 d-flex align-items-center"
        />
        <h4 className="heading">{props.reportName}</h4>
      </View>
      {reportToSave && (
        <View direction="row" gap={2}>
          <ButtonGroup>
            <Button materialIcon="save" onClick={handleSaveReport}>
              {props.t("SAVE")}
            </Button>
            <ContextMenu
              align="left"
              clickTriggerEl={<Button color="black" iconSize={1.3} materialIcon="more_vert" />}
            >
              <MenuItem
                key={"save_as"}
                label={props.t("SAVE_AS_NEW")}
                onClick={handleSaveAsReport}
              />
            </ContextMenu>
          </ButtonGroup>
        </View>
      )}
    </View>
  );
}

const mapDispatchToProps: PropsFromDispatch = {
  toggleSaveReportModal: actionCreators.ToggleSaveReportModal,
};

export default compose(localize(), connect(null, mapDispatchToProps))(ReportTitle);
